<template>
    <div>
        <limitless-page-header title="Prislista Återförsäljare"></limitless-page-header>

        <div class="content">
            <div class="row">
                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <p>
                                ALLA Återförsäljare har 40% marginal på kortpriset.
                            </p>
                            <p>
                                (OBS! Ej någon rabatt på frakten)
                            </p>

                            <div class="table-responsive">
                                <table class="table table-striped table-condensed">
                                    <thead>
                                        <tr>
                                            <th width="95">Kort</th>
                                            <th width="75" class="text-right">Pris slutkund</th>
                                            <th width="75" class="text-right">Frakt</th>
                                            <th width="75" class="text-right">ÅF-pris m frakt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Supreme</td>
                                            <td class="text-right">480 kr</td>
                                            <td class="text-right">79 kr</td>
                                            <td class="text-right">367,00</td>
                                        </tr>
                                        <tr>
                                            <td>Delight</td>
                                            <td class="text-right">240 kr</td>
                                            <td class="text-right">79 kr</td>
                                            <td class="text-right">223,00</td>
                                        </tr>
                                        <tr>
                                            <td>Selection</td>
                                            <td class="text-right">150 kr</td>
                                            <td class="text-right">49 kr</td>
                                            <td class="text-right">139,00</td>
                                        </tr>
                                        <tr>
                                            <td>Summer</td>
                                            <td class="text-right">256 kr</td>
                                            <td class="text-right">79 kr</td>
                                            <td class="text-right">232,60</td>
                                        </tr>
                                        <tr>
                                            <td>Premium Delight</td>
                                            <td class="text-right">1500 kr</td>
                                            <td class="text-right">199 kr</td>
                                            <td class="text-right">1099,00</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5>Supékort Exclusive: (Hänvisa dessa kunder till Säljare)</h5>
                            <ul>
                                <li>Vi erbjuder kunderna ett profilerat kort ”skräddarsytt” färger, logos, bilder</li>
                                <li>Kortet ingår också en personlig hälsning på webbsidan och i kortet.</li>
                                <li>Det fysiska kortet kan innehålla max 30 produkter.</li>
                                <li>Fler produkter kan läggas upp på hemsidan.</li>
                                <li>För att kunna välja Supékort Exclusive ska upplagan ligga runt 700st kort.</li>
                            </ul>

                            <h5>Tryckt hälsning och logo:</h5>
                            <p>Startkostnad 550 kr + 6 kr/ kort exkl. moms</p>

                            <h5>Webbsida och hälsning:</h5>
                            <p>Vid en beställning på färre än 100 supékort, tillkommer en engångskostnad på 850 kr exkl. moms.</p>

                            <h5>Kuvertering &amp; porto:</h5>
                            <p>
                                Porto 18 kr/kort exkl. moms<br>
                                Kuvertering 15 kr/kort exkl. moms
                            </p>

                            <h5>Stafflingsprislista:</h5>
                            <div class="table-responsive">
                                <table class="table table-striped table-condensed">
                                    <thead>
                                        <tr>
                                            <th width="135"></th>
                                            <th width="75" class="text-right">1 st</th>
                                            <th width="75" class="text-right">250-450 st</th>
                                            <th width="75" class="text-right">451-999 st</th>
                                            <th width="75" class="text-right">1 000-5 000 st</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Supreme</td>
                                            <td class="text-right">367,00</td>
                                            <td class="text-right">353,00</td>
                                            <td class="text-right">345,00</td>
                                            <td class="text-right">338,00</td>
                                        </tr>
                                        <tr>
                                            <td>Delight</td>
                                            <td class="text-right">223,00</td>
                                            <td class="text-right">218,00</td>
                                            <td class="text-right">214,00</td>
                                            <td class="text-right">211,00</td>
                                        </tr>
                                        <tr>
                                            <td>Selection</td>
                                            <td class="text-right">135,00</td>
                                            <td class="text-right">130,00</td>
                                            <td class="text-right">126,00</td>
                                            <td class="text-right">123,00</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';

export default {
    name: 'CardOrderResellerPrices',
    components: {
        LimitlessPageHeader,
    },
};
</script>
